import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Alert,
  Input,
} from "reactstrap";
import * as FaIcons from "react-icons/fa";
import "../Bec/bec.scss";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "jspdf-autotable";
import logos from "../../components/img/base/111.png";
import axios from "axios";
import Swal from "sweetalert2";

const GestionUsuarios = () => {
  // Todos los Hooks al inicio
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modal, setModal] = useState(false);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [accion, setAccion] = useState(""); // 'habilitar' o 'bloquear'
  const [procesando, setProcesando] = useState(false);
  const [sortField, setSortField] = useState(null);
  const [order, setOrder] = useState("asc");
  const [busqueda, setBusqueda] = useState("");
  const [tablaUsuarios, setTablaUsuarios] = useState([]);

  // URL de tu API PHP
  const API_URL = "https://bqef-bo.com/api/A/apiDash.php";
  ////Datos usuario Administrador
  const [dataAdm, setDataAdm] = useState({});
  const peticionGetAdm = async () => {
    setLoading(true);
    setError("");
    const adminId = sessionStorage.getItem("iduser");
    try {
      const res = await axios.get(`${API_URL}?action=getInfoAdm&id=${adminId}`);
      const receivedData =
        res.data.InfoAdm && Array.isArray(res.data.InfoAdm)
          ? res.data.InfoAdm
          : [];
      // console.log(res.data);
      setDataAdm(receivedData);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error al cargar los datos.",
        footer: `Código de error: ${error.response.status}`,
      });
    }
  };
  // Función para obtener usuarios
  const fetchUsuarios = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API_URL}?action=getEstBec`);
      const receivedData =
        res.data.EstadoBec && Array.isArray(res.data.EstadoBec)
          ? res.data.EstadoBec
          : [];
      // console.log(receivedData);
      setTablaUsuarios(receivedData);
      setUsuarios(receivedData);
    } catch (err) {
      setError("Error al cargar los usuarios");
    } finally {
      setLoading(false);
    }
  };

  // Ejecutar al montar el componente
  useEffect(() => {
    fetchUsuarios();
    peticionGetAdm();
  }, []);

  // Función para abrir modal y definir acción
  const handleOpenModal = (usuario, accion) => {
    setUsuarioSeleccionado(usuario);
    setAccion(accion);
    setModal(true);
  };

  // Función para cerrar modal
  const handleCloseModal = () => {
    setModal(false);
    setUsuarioSeleccionado(null);
    setAccion("");
  };

  // Función para habilitar o bloquear usuario
  const handleCambiarEstado = async () => {
    if (!usuarioSeleccionado) return;
    setProcesando(true);

    let idAdm = null;
    if (Array.isArray(dataAdm) && dataAdm.length > 0 && dataAdm[0].id_adm) {
      idAdm = dataAdm[0].id_adm;
    } else {
      console.error("No se encontró id_adm");
      setProcesando(false);
      return;
    }

    try {
      const res = await axios({
        url: `${API_URL}?action=updateEstadoBec`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          id_bec: usuarioSeleccionado.id_bec,
          estado: accion === "habilitar" ? "activo" : "bloqueado",
          usu_modificacion: idAdm,
        },
      });

      if (!res.data) {
        console.error("Respuesta vacía del servidor");
        alert("No se recibió respuesta del servidor");
        return;
      }

      if (res.data.success) {
        setUsuarios((prevUsuarios) =>
          prevUsuarios.map((u) =>
            u.id === usuarioSeleccionado.id_bec
              ? {
                  ...u,
                  estado:
                    res.data.estado ||
                    (accion === "habilitar" ? "activo" : "bloqueado"),
                }
              : u
          )
        );
        handleCloseModal();
        fetchUsuarios();
        mostrarAlertaU();
      } else {
        mostrarAlertaError();
        alert("Error: " + res.data.message);
      }
    } catch (err) {
      alert("Error en la solicitud");
    } finally {
      setProcesando(false);
    }
  };
  ////ALERTAS
  const mostrarAlertaU = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Éxito!",
      text: "Estado Modificado.",
      timer: 5000,
      icon: "success",
    });
  };
  const mostrarAlertaError = () => {
    Swal.fire({
      confirmButtonColor: "#2E8B57",
      title: "Error!",
      text: "No se pudo modificar.",
      timer: 5000,
      icon: "error",
    });
  };
  ///carga
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        Cargando...
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }
  //////Filtrar columnas
  const handleSortingChange = (accessor) => {
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
  };
  const sortedData = usuarios.sort((a, b) => {
    if (a[sortField] < b[sortField]) {
      return order === "asc" ? -1 : 1;
    }
    if (a[sortField] > b[sortField]) {
      return order === "asc" ? 1 : -1;
    }
    return 0;
  });
  ////BARRA BUSQUEDA
  const handleChangeB = (e) => {
    setBusqueda(e.target.value);
    filtrar(e.target.value);
  };

  const filtrar = (terminoBusqueda) => {
    const searchTermLower = terminoBusqueda.toLowerCase();

    const resultadosBusqueda = tablaUsuarios.filter(
      (elemento) =>
        (elemento.id?.toString() || "")
          .toLowerCase()
          .includes(searchTermLower) ||
        (elemento.nombre?.toString() || "")
          .toLowerCase()
          .includes(searchTermLower) ||
        (elemento.apellido?.toString() || "")
          .toLowerCase()
          .includes(searchTermLower) ||
        (elemento.email?.toString() || "")
          .toLowerCase()
          .includes(searchTermLower) ||
        (elemento.estado?.toString() || "")
          .toLowerCase()
          .includes(searchTermLower)
    );

    setUsuarios(resultadosBusqueda);
  };
  ///GENERAR PDF INFORME
  const generatePDF = () => {
    // Crear un nuevo documento PDF en orientación horizontal (landscape)
    const doc = new jsPDF("portrait");

    // Propiedades del documento (puedes incluir título, autor, etc.)
    doc.setProperties({
      title: "Reporte Estado Cuenta Becarios",
      author: "BQEF",
      subject: "Reporte de estado",
      keywords: "estado becarios, reporte, datos",
      creator: "jsPDF",
    });

    // Agregar logo al documento PDF
    doc.addImage(logos, "PNG", 10, 10, 20, 10);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Agregar título "FONDO DE EDUCACIÓN" al documento PDF
    doc.setFontSize(12);
    const title = "FONDO DE EDUCACION DE CUAQUEROS BOLIVIANOS";
    const titleWidth = doc.getTextWidth(title);
    const x = (doc.internal.pageSize.width - titleWidth) / 2; // Calcular posición X para centrar
    const y = 20; // Posición Y del título

    // Escribir el título
    doc.text(title, x, y);

    // Dibujar la línea subrayando el título
    doc.line(x, y + 1, x + titleWidth, y + 1); // Dibuja la línea

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar subtítulo "Reporte" al documento PDF
    const subtitle = "Reporte Estado Cuenta Becarios";
    const subtitleWidth = doc.getTextWidth(subtitle);
    const subtitleX = (doc.internal.pageSize.width - subtitleWidth) / 2; // Calcular posición X para centrar
    doc.text(subtitle, subtitleX, 30);

    // Agregar fecha al documento PDF
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    doc.setFontSize(9);
    doc.text(`Fecha: ${dia}/${mes}/${año}`, 10, 25);

    // Establecer la fuente en negrita
    doc.setFont("helvetica", "bold");

    // Definir el texto "Usuario: "
    const usuarioText = "Usuario: Personal Administrativo";

    // Calcular el ancho del texto
    const usuarioWidth = doc.getTextWidth(usuarioText);

    // Calcular la posición X para alinearlo a la derecha
    const usuarioX = doc.internal.pageSize.width - usuarioWidth - 10; // 10 mm de margen desde el borde derecho

    // Escribir el texto "Usuario:" en la posición calculada
    doc.text(usuarioText, usuarioX, 35);

    // Definir los datos de la tabla
    const userData = usuarios
      .map((iteb) => ({
        nom_b: `${iteb.nombre} ${iteb.apellido}`,
        email: iteb.email,
        id_bec: iteb.id_bec,
        estado: iteb.estado,
      }))
      .sort((a, b) => a.nom_b.localeCompare(b.nom_b)) // Ordenar por nombre en orden alfabético ascendente
      .map((iteb, nb) => ({
        it: nb + 1, // Asignar el índice de forma ascendente después de ordenar
        ...iteb, // Desestructurar el resto de las propiedades
      }));

    // Definir las columnas de la tabla
    const columns = [
      { header: "N°", dataKey: "it" },
      { header: "Nombre Becario", dataKey: "nom_b" },
      { header: "Correo", dataKey: "email" },
      { header: "ID Usuario", dataKey: "id_bec" },
      { header: "Estado", dataKey: "estado" },
    ];

    // Restablecer la fuente a normal
    doc.setFont("helvetica", "normal");

    // Agregar la tabla al documento PDF
    autoTable(doc, {
      columns: columns,
      body: userData,
      startY: 40,
      margin: { top: 20, bottom: 20 },
      bodyStyles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [10, 49, 67] },
    });

    // Agregar número de página al documento PDF
    let totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.text(
        `Página ${i} de ${totalPages}`,
        10,
        doc.internal.pageSize.height - 10
      );
    }

    // Convertir el documento PDF a blob
    const pdfBlob = doc.output("blob");

    // Abrir el PDF en una nueva ventana
    const url = URL.createObjectURL(pdfBlob);
    window.open(url, "_blank");
  };
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Gestión Cuentas Becarios</h2>
        </div>
        <div className="frm">
          <Button color="primary" size="lg" onClick={generatePDF}>
            <FaIcons.FaFileDownload /> Reporte
          </Button>
        </div>

        <div className="frm containerInput">
          <Input
            className="form-control inputBuscar"
            bsSize="lg"
            value={busqueda}
            placeholder="Búsqueda por Nombre, Apellido o Email"
            onChange={handleChangeB}
          />
          <Button className="btn btn-success" size="lg">
            <FaIcons.FaSearch /> Buscar
          </Button>
        </div>
        <Table className="frm" responsive="sm" id="tabl">
          <thead id="stahead">
            <tr className="text-center">
              <th>ID</th>
              <th>
                <span onClick={() => handleSortingChange("nombre")}>
                  Nombres
                  {sortField === "nombre" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "nombre" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("apellido")}>
                  Apellidos
                  {sortField === "apellido" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "apellido" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("email")}>
                  Correo
                  {sortField === "email" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "email" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("id_bec")}>
                  ID Usuario
                  {sortField === "id_bec" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "id_bec" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>
                <span onClick={() => handleSortingChange("estado")}>
                  Estado
                  {sortField === "estado" && order === "asc" ? (
                    <FaIcons.FaSortUp />
                  ) : sortField === "estado" && order === "desc" ? (
                    <FaIcons.FaSortDown />
                  ) : (
                    <FaIcons.FaSort />
                  )}
                </span>
              </th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((usuario, index) => (
              <tr key={usuario.id_bec}>
                <td>{index + 1}</td>
                <td>{usuario.nombre}</td>
                <td>{usuario.apellido}</td>
                <td>{usuario.email}</td>
                <td>{usuario.id_bec}</td>
                <td>{usuario.estado}</td>
                <td>
                  {usuario.estado === "activo" ? (
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => handleOpenModal(usuario, "bloquear")}
                    >
                      Bloquear
                    </Button>
                  ) : (
                    <Button
                      color="success"
                      size="sm"
                      onClick={() => handleOpenModal(usuario, "habilitar")}
                    >
                      Habilitar
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* Modal de confirmación */}
        <Modal isOpen={modal} toggle={handleCloseModal}>
          <ModalHeader className="header_mo">Confirmación</ModalHeader>
          <ModalBody>
            {usuarioSeleccionado && (
              <p>
                ¿Estás seguro de{" "}
                {accion === "habilitar" ? "habilitar" : "bloquear"} la cuenta de{" "}
                <strong>{usuarioSeleccionado.nombre}</strong>?
              </p>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              onClick={handleCambiarEstado}
              disabled={procesando}
            >
              {procesando ? "Procesando..." : "Sí"}
            </Button>{" "}
            <Button
              color="danger"
              onClick={handleCloseModal}
              disabled={procesando}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default GestionUsuarios;
